import "./Header.scss";

import React from "react";
import { useLocation } from "react-router-dom";
import SideMenu from "../side-menu/SideMenu";
import MenuItems from "./MenuItems";
import SearchIcon from "./SearchIcon";

const Header: React.FC<{
	className?: string;
	children?: any;
	showEmptyHeader?: boolean;
}> = ({ className, children, showEmptyHeader }) => {
	const location = useLocation();

	const isSignUpFlow =
		location.pathname.includes("sign-up") || !!showEmptyHeader;

	const setBackButton = (route: string) => {
		if (route === "profile" || route === "/type" || route === "/info") {
			return <></>;
		} else {
			return <SideMenu />;
		}
	};

	const setHeader = (isSignUpFlow: boolean) => {
		if (isSignUpFlow)
			return <div className={"header__sign-up " + className}>{children}</div>;
		else
			return (
				<div className={"header " + className}>
					<div
						className={"d-flex gap-5"}
						style={{ width: "100%" }}
					>
						{setBackButton(location.pathname)}
						<MenuItems />
					</div>
					<SearchIcon />
				</div>
			);
	};

	return setHeader(isSignUpFlow);
};

export default Header;
